import { joinURL } from 'ufo'

export function useUrl() {
  function formatUrl(url: string, useToken: boolean) {
    const { accessToken } = storeToRefs(useAuthStore())
    const { baseURL } = useEnvStore()

    return useToken
      ? joinURL(baseURL, 'api', `${url}?access_token=${accessToken.value}`)
      : joinURL(baseURL, 'api', url)
  }

  function getUploadFileUrl(
    fileName: string,
    type: 'account' | 'productMain' | 'product' | 'service'
  ) {
    const { baseURL } = useEnvStore()

    return joinURL('/', baseURL, 'upload', type, fileName)
  }

  return {
    formatUrl,
    getUploadFileUrl
  }
}
